import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const COURSE = 'course'
const TITLE = 'title'
const IMPORTANCE = 'importance'
const SCORE_TYPE = 'score_type'

const RUBRIC = 'rubric'
const EXTRA_CREDIT = 'extra_credit'
const RELEASE_SCORES = 'release_scores'
const FINAL_GRADE = 'final_grade'
const UNGRADED = 'ungraded'

/**
 * Form model
 */
const formModel = () => {
  return {
    [COURSE]: {
      label: `${t('common.course')}`,
      name: COURSE,
      required: true,
    },
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [IMPORTANCE]: {
      label: `${t('common.importance')}`,
      name: IMPORTANCE,
      required: true,
    },
    [SCORE_TYPE]: {
      label: `${t('common.score-type')}`,
      name: SCORE_TYPE,
      required: true,
    },

    [RUBRIC]: {
      label: `${t('common.rubric')}`,
      name: RUBRIC,
    },
    [RELEASE_SCORES]: {
      label: `${t('assignments.release-scores')}`,
      name: RELEASE_SCORES
    },
    [EXTRA_CREDIT]: {
      label: `${t('assignments.extra-credit')}`,
      name: EXTRA_CREDIT,
    },
    [FINAL_GRADE]: {
      label: `${t('assignments.counts-in-final-grade')}`,
      name: FINAL_GRADE,
    },
    [UNGRADED]: {
      label: `${t('assignments.give-ungraded-no-credit')}`,
      name: UNGRADED,
    },

  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [COURSE]: null,
  [TITLE]: '',
  [IMPORTANCE]: 0,
  [SCORE_TYPE]: null,

  [RUBRIC]: null,
  [RELEASE_SCORES]: false,
  [EXTRA_CREDIT]: false,
  [FINAL_GRADE]: false,
  [UNGRADED]: false


}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [COURSE]: yup
    .object()
    .shape({
      title: yup
        .string()
        .nullable()
        .required(`${t('required-error-message')}`),
    })
    .nullable()
    .required(`${t('errors.required-error-message')}`),
    [TITLE]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [IMPORTANCE]: yup
      .number()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [SCORE_TYPE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
